import React from 'react';
import { Navbar as BootstrapNavbar } from 'react-bootstrap';

const Navbar = ({ 
    children, 
    brand, 
    brandHref = '/', 
    bg = 'light', 
    variant = 'light', 
    expand = 'lg', 
    fixed, // 'top' or 'bottom'
    sticky = null, // 'top' to enable sticky
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    shadow = true,
    ...props 
}) => {
    // If sticky is true (boolean), convert to 'top'
    const stickyValue = sticky === true ? 'top' : sticky;
    
    // Add shadow for sticky/fixed navbar
    const navbarStyle = {
        boxShadow: (fixed || sticky) && shadow ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
        transition: 'all 0.3s ease',
        ...style
    };

    return (
        <BootstrapNavbar 
            bg={bg} 
            variant={variant} 
            expand={expand}
            fixed={fixed}
            sticky={stickyValue}
            className={className} 
            style={navbarStyle}
            {...props}
        >
            {brand && (
                <BootstrapNavbar.Brand href={brandHref}>
                    {brand}
                </BootstrapNavbar.Brand>
            )}
            {/* <BootstrapNavbar.Toggle aria-controls="navbar-nav" /> */}
            {/* <BootstrapNavbar.Collapse id="navbar-nav"> */}
                {children}
            {/* </BootstrapNavbar.Collapse> */}
        </BootstrapNavbar>
    );
};

export default Navbar;

